import InputField from '@Components/Input';
import FormWrapper from '@Components/ProfilePage/FormWrapper';
import { useAuth } from '@Contexts/AuthContext/Auth.context';
import { _UpdateProfile } from '@Services/Authentication';
import { AxiosError } from 'axios';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Error, Form, Input } from './EditProfileForm.styled';
type Props = {
  setIsFormSuccess: React.Dispatch<React.SetStateAction<boolean>>;
};

type Form = {
  full_name: string;
  mobile?: string | null;
  email?: string | null;
  birth_date?: string | null;
};

export default function EditProfileForm({ setIsFormSuccess }: Props) {
  const { t } = useTranslation('Profile');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [submitHasError, setSubmitHasError] = useState<string>('');
  const { userData, setUserData } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Form>({
    defaultValues: {
      full_name: userData?.full_name,
      mobile: userData?.mobile,
      email: userData?.email,
      birth_date: userData?.birth_date,
    },
  });

  const onSubmit: SubmitHandler<Form> = (formData) => {
    setIsLoading(true);
    _UpdateProfile(formData)
      .then(({ data }) => {
        setUserData(data);
        setIsFormSuccess(true);
        setIsLoading(false);
      })
      .catch((err: AxiosError) => {
        const message = Object.keys(err.response?.data)[0];
        setSubmitHasError(err.response?.data?.[message] || '');
        setIsLoading(false);
      });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormWrapper title={t('edit_profile')} cta={t('save')} error={submitHasError} loading={isLoading}>
        <InputField label={t('full_name')}>
          <Input placeholder={t('full_name')} type="text" {...register('full_name', { required: true })} />
          <Error>{errors.full_name?.message && <span>{t('name_error')}</span>}</Error>
        </InputField>
        <InputField label={t('phone')}>
          <Input dir="ltr" placeholder={t('phone')} type="text" {...register('mobile', { required: true })} />
          <Error>{errors.mobile && <span>{t('phone_error')}</span>}</Error>
        </InputField>
        <InputField label={t('email')}>
          <Input placeholder={t('email')} type="email" {...register('email', { required: true })} />
          <Error>{errors.email && <span>{t('email_error')}</span>}</Error>
        </InputField>
        <InputField label={t('birthdate')}>
          <Input dir="ltr" placeholder={t('birthdate')} type="date" {...register('birth_date', { required: true })} />
          <Error>{errors.birth_date && <span>{t('birth_date')}</span>}</Error>
        </InputField>
      </FormWrapper>
    </Form>
  );
}
